import { DatedEvidence, TableCells, TableFilterCells } from '@eas/common-web';
import { NonStandardState } from '@models';
import { useIntl } from 'react-intl';
import {
  useNonStandardStateLevels,
  useSeverity,
} from './non-standard-states-api';

export const useColumns = () => {
  const intl = useIntl();
  const { datedColumns } = DatedEvidence.useDatedColumns<NonStandardState>();

  return [
    {
      datakey: 'name',
      name: intl.formatMessage({
        id: 'TAPIS__NON_STANDARD_STATE__COLUMN__NAME',
        defaultMessage: 'Název',
      }),
      width: 250,
      CellComponent: TableCells.TextCell,
      sortable: true,
      filterable: true,
    },
    {
      datakey: 'code',
      name: intl.formatMessage({
        id: 'TAPIS__NON_STANDARD_STATE__COLUMN__CODE',
        defaultMessage: 'Kód',
      }),
      width: 250,
      CellComponent: TableCells.TextCell,
    },
    {
      datakey: 'severity',
      name: intl.formatMessage({
        id: 'TAPIS__NON_STANDARD_STATE__COLUMN__SEVERITY',
        defaultMessage: 'Vážnost',
      }),
      width: 120,
      CellComponent: TableCells.TextCell,
      valueMapper: TableCells.useSelectCellFactory(useSeverity),
    },
    {
      datakey: 'level',
      sortkey: 'level.name',
      filterkey: 'level.id',
      name: intl.formatMessage({
        id: 'TAPIS__NON_STANDARD_STATE__COLUMN__LEVEL',
        defaultMessage: 'Úroveň',
      }),
      width: 120,
      CellComponent: TableCells.TextCell,
      valueMapper: TableCells.useSelectCellFactory(useNonStandardStateLevels),
      FilterComponent: TableFilterCells.useFilterSelectCellFactory(
        useNonStandardStateLevels
      ),
      sortable: true,
      filterable: true,
    },
    ...datedColumns,
  ];
};
